module.exports = __webpack_public_path__ + "img/check-nor.a5deafaf.svg";